import { toast } from '@/components/ui/use-toast';
import {
	usePushNextMarketToLiveMutation,
	useVoidMarketMutation,
} from '@/store/api/market-manage.api';

export function useLiveMarketControls({ currentCrowdLobby }: { currentCrowdLobby: any }) {
	const [voidMarket, { isLoading: isVoidingMarket }] = useVoidMarketMutation();
	const [pushNextMarketToLive, { isLoading: isPushingNext }] = usePushNextMarketToLiveMutation();

	const handleVoidMarket = async (marketId: string) => {
		try {
			await voidMarket({ marketId }).unwrap();

			toast({
				title: 'Market voided',
				description: 'The market has been successfully voided.',
			});
		} catch (err) {
			console.error('Void market failed', err);
			toast({
				variant: 'destructive',
				title: 'Error',
				description: 'Failed to void market',
			});
		}
	};

	const handlePushNextLiveMarket = async (marketId: string) => {
		try {
			await pushNextMarketToLive({
				marketId,
				marketOpenDelay: currentCrowdLobby?.market_open_delay ?? 15,
			}).unwrap();
		} catch (err) {
			console.error('Push next live failed', err);
		}
	};

	return {
		isVoidingMarket,
		isPushingNext,
		handleVoidMarket,
		handlePushNextLiveMarket,
	};
}
